import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { from } from '@helpers/media';
import { h2, paragraphRegular } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  min-height: 100px;
  height: 100%;
  overflow: hidden;
  padding: 0;
`;
const Grid = styled.div `
  --bgColour: ${brand.primary.purple.dark};

  [data-variant=${BrandColours.BlueDark}] & {
    --bgColour: ${brand.primary.blue.dark};
  }

  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: ${fluid(40, 42)} ${fluid(16, 144)} ${fluid(40, 94)};
  background-color: var(--bgColour);

  @media ${from(866)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${fluid(16, 32)};
    border-radius: ${fluid(10, 20)};
  }
`;
const ImageArea = styled.div `
  ${transition('opacity, transform', 0.5)};
  position: relative;
  ${imageWrapperPreserveRatio(695, 392)};
  overflow: visible;
  transition-delay: 0.3s;

  [data-animate='false'] & {
    opacity: 0;
    transform: translateY(80px);
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(695, 392)};

  display: grid;
  place-content: center;
  margin-bottom: 0;
  border-radius: 10px 10px 0 0;
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ImageReflection = styled(ImageContainer) `
  ${transition('opacity', 0.5)};
  position: absolute;
  top: 100%;
  left: 0;
  transform: scaleY(-1);
  opacity: 0.5;
  transition-delay: 0.6s;

  [data-animate='false'] & {
    opacity: 0;
  }
`;
const ContentArea = styled.div `
  ${transition('opacity, transform', 0.5)};
  color: ${brand.global.white};
  align-self: center;

  [data-animate='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }
`;
const Heading = styled.h2 `
  ${h2}

  font-size: ${fluid(32, 48)};
  line-height: ${fluid(40, 56)};
  margin-bottom: ${fluid(8, 12)};
  text-transform: uppercase;
`;
const CtaArea = styled.div `
  margin-top: auto;
  display: flex;
  gap: ${fluid(15, 15)};
`;
const Content = styled.div `
  ${paragraphRegular};
  font-size: ${fluid(14, 18)};
  line-height: ${fluid(22, 28)};
`;
const DownloadCardStyles = {
    Container,
    Content,
    ContentArea,
    CtaArea,
    Grid,
    Heading,
    Image,
    ImageArea,
    ImageContainer,
    ImageReflection,
};
export default DownloadCardStyles;
